<template>
	<loginBase element-loading-text="登录中,请稍后..." element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.2)" minheight="480px">
		<div>
			<div class="imgT"></div>
			<div class="title">
				<span class="title_active">区域账号登录</span>
			</div>

			<el-form class="loginForm" :model="form" :hide-required-asterisk="true" :rules="rules" ref="loginForm"
				label-width="80px" label-position="top">
				<el-form-item label="手机号码" prop="mobile">
					<el-input @keyup.enter.native="sureLogin" v-model="form.mobile" placeholder="请输入手机号码"></el-input>
				</el-form-item>
				<el-form-item label="登录密码" prop="password">
					<el-input @keyup.enter.native="sureLogin" v-model="form.password" type="password"
						placeholder="请输入密码"></el-input>
				</el-form-item>
				<el-form-item style="position: absolute; bottom: 15px; width: 308px">
					<el-button @keyup.enter.native="sureLogin" @click="sureLogin" type="primary"
						style="width: 100%; height: 50px; font-size: 16px">{{ !loginLoading ? "登录" : "登录中，请稍等" }}</el-button>
					<p class="agrement">
						登录即表示同意<a href="">《注册协议》</a><a href="">《个人信息处理规则》</a>
					</p>
				</el-form-item>
			</el-form>
		</div>
	</loginBase>
</template>

<script>
	import {
		eltips
	} from "@/util/util";
	import loginBase from '@/views/login/login/components/base.vue';
	import {
		resetRouter
	} from "@/router/index.js";
	import {
		clearAuthSessionData,
		clearSnapshot
	} from "@/util/authSession";

	export default {
		components: {
			loginBase,
		},
		data() {
			return {
				form: {
					mobile: "",
					password: "",
				},
				rules: {
					mobile: [{
						required: true,
						message: "请输入手机号码",
						trigger: "blur"
					}],
					password: [{
						required: true,
						message: "请输入密码",
						trigger: "blur"
					}],
				},
				loginLoading: false,
			};
		},
		created() {
			this.clearLoginSession();
			sessionStorage.setItem("loginPage", this.regionLoginPage());
		},
		methods: {
			regionShopId() {
				const routeShopId = this.$route.query.shop_id || this.$route.query.shopid;
				if (routeShopId) {
					return routeShopId;
				}
				const search = new URLSearchParams(window.location.search || "");
				return search.get("shop_id") || search.get("shopid") || "";
			},
			regionLoginPage() {
				const shopId = this.regionShopId();
				return shopId ? "/regionlogin?shop_id=" + encodeURIComponent(shopId) : "/regionlogin";
			},
			clearLoginSession() {
				resetRouter();
				this.$store.commit("routestatus", 0);
				clearAuthSessionData(sessionStorage);
				clearSnapshot();
			},
			sureLogin() {
				if (this.loginLoading) {
					return false;
				}
				this.$refs.loginForm.validate((valid) => {
					if (!valid) {
						return false;
					}
					this.regionLogin();
				});
			},
			regionLogin() {
				this.loginLoading = true;
				this.clearLoginSession();
				sessionStorage.setItem("loginPage", this.regionLoginPage());
				this.axios.post("/api/shop/basic/region-login", {
					shop_id: this.regionShopId(),
					mobile: this.form.mobile,
					password: this.form.password,
				}).then((res) => {
					if (res.code == 200) {
						const routes = this.traverseTree(res.data.menu_list || []);
						const user = res.data.user || {};
						const regionContext = res.data.region_context || {};
						const target = this.firstVisibleRegionPath(routes) || "/region/overview";
						sessionStorage.setItem("loginPage", this.regionLoginPage());
						sessionStorage.setItem("guardName", "shop_user");
						sessionStorage.setItem("accountScope", "region");
						sessionStorage.setItem("token", res.data.token);
						sessionStorage.setItem("userinfo", JSON.stringify(user));
						sessionStorage.setItem("shopid", user.shop_id);
						sessionStorage.setItem("regionContext", JSON.stringify(regionContext));
						if (regionContext.default_store_id) {
							sessionStorage.setItem("currentRegionStoreId", String(regionContext.default_store_id));
						}
						sessionStorage.setItem("routes", JSON.stringify(routes));
						eltips(res.msg, "success");
						this.$router.replace({
							path: target,
						});
					} else {
						eltips(res.msg, "error");
					}
					setTimeout(() => {
						this.loginLoading = false;
					}, 1000);
				}).catch(() => {
					this.loginLoading = false;
				});
			},
			firstVisibleRegionPath(routes) {
				for (let i = 0; i < routes.length; i += 1) {
					const item = routes[i];
					if (item.path && item.layout != "2" && item.path.indexOf("/region/") === 0) {
						return item.path;
					}
					const childPath = this.firstVisibleRegionPath(item._child || []);
					if (childPath) {
						return childPath;
					}
				}
				return "";
			},
			traverseTree(treeList) {
				const keyMap = {
					id: "id",
					menuName: "name",
					title: "name",
					uri: "component",
					url: "path",
					icon_url: "icon",
					layout: "layout",
					router_name: "router_name",
					vue_name: "vue_name",
					app_level: "app_level",
					plugin: "plugin",
					is_plugin: "is_plugin",
				};
				return (treeList || []).map((item) => {
					const mapped = Object.keys(keyMap).reduce((acc, oldKey) => {
						const newKey = keyMap[oldKey];
						acc[newKey] = item[oldKey];
						return acc;
					}, {});
					mapped._child = item.children ? this.traverseTree(item.children) : [];
					return mapped;
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.imgT {
		position: absolute;
		right: 0;
		top: 0;
		width: 90px;
		height: 90px;
		border-radius: 0 10px 0 0;
		border-color: #f2f7ff #f2f7ff #fff #fff;
		border-style: solid;
		border-width: 50px;
		box-sizing: border-box;
	}

	.title {
		margin-top: 12px;

		span {
			font-size: 20px;
			color: #b6babf;
			cursor: pointer;
			font-weight: 400;
			transition: color 0.2s linear;
		}

		&_active {
			color: #1e2226 !important;
			font-weight: 600 !important;
		}
	}

	.loginForm {
		margin-top: 30px;
	}

	.loginForm ::v-deep .el-form-item__label {
		padding-bottom: 0;
		font-weight: 600;
		color: #1f2026;
		font-size: 14px;
	}

	.agrement {
		display: flex;
		color: #8a9099;
		justify-content: center;
		margin-top: 10px;
		height: 19px;
		line-height: 20px;
		font-size: 12px;

		a {
			color: #1e2226;
		}
	}
</style>
